var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StandardIconBloc',{attrs:{"icon":"x-circle-fill","backColor":"rgb(255,235,230)","frontColor":"rgb(222,53,11)"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }